import type { TranslationQuoteView } from '@/features/ai/useTranslationQuote'

export interface TranslateGates {
  /** Смета не приехала И больше не летит. */
  quoteFailed: boolean
  /** Мягкий режим: переводится `pending_units`. */
  canSoft: boolean
  /** Разрушительный режим: переводится `total_units`. */
  canHard: boolean
}

/**
 * Живы ли кнопки перевода. Потолка единиц больше нет (§6.3): большой курс
 * переводится одним прогоном, и сравнивать объём с `max_units` нельзя — у
 * сервера там `null`, а `13 > null` в JS истинно.
 */
export const translateGates = (quote: TranslationQuoteView, busy: boolean): TranslateGates => ({
  quoteFailed: quote.pendingUnits === undefined && !quote.isLoading,
  canSoft: Boolean(quote.pendingUnits) && !busy,
  canHard: Boolean(quote.totalUnits) && !busy,
})
